<template>
  <div v-if="$auth.ready() && dataReady">
    <div class="be-wrapper be-fixed-sidebar">
      <nav-header></nav-header>
      <left-sidebar></left-sidebar>
      <router-view/>
    </div>
    <vue-snotify></vue-snotify>
  </div>
  <div v-else>
    <div class="be-content">
      <div class="main-content container-fluid">

        <div class="splash-container">
          <div class="be-loading-active">
            <h4>Инициализация портала...</h4>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>
<script>
  import Vue from 'vue'
  import 'pace-js/themes/blue/pace-theme-minimal.css'
  import Pace from 'pace-js'
  import NavHeader from '@/components/NavHeader'
  import LeftSidebar from '@/components/LeftSidebar'
  import Snotify, {SnotifyPosition} from 'vue-snotify'
  import {USER_ROLE_GUEST, USER_ROLE_REGISTERED, USER_ROLE_ADMIN} from "./constants"

  Vue.use(Snotify, {
    toast: {
      position: SnotifyPosition.rightBottom,
      showProgressBar: true,
      titleMaxLength: 50,
      timeout: 5000
    }
  })

  let jwtDecode = require('jwt-decode')
  export default {
    name: 'App',
    data() {
      return {
        dataReady: false
      }
    },
    components: {
      navHeader: NavHeader,
      LeftSidebar: LeftSidebar
    },
    created() {
      Pace.start({
        'ajax': {'trackWebSockets': false},
        'restartOnRequestAfter': true
      })
      let self = this
      this.$auth.ready(function () {
        if (!this.$auth.check()) {
          this.dataReady = true
        } else {
          this.dataReady = false
          this.$auth.refresh({
            data: {'token': this.$auth.token()}, // data: {} in Axios
            success: function () {
            },
            error: function () {
            }
          })
          this.$auth.user(jwtDecode(this.$auth.token()))
          if (self.$auth.user().is_superuser) {
                  this.$user.set({role: USER_ROLE_ADMIN})
                } else if (self.$auth.user().is_guest) {
                  this.$user.set({role: USER_ROLE_GUEST})
                } else {
                  this.$user.set({role: USER_ROLE_REGISTERED})
                }
          self.$store.dispatch('init').then(() => {
            this.dataReady = true
          })

        }
      })
    },
    methods: {
      logout() {
        this.$auth.logout({
          makeRequest: false,
          success() {
            this.$router.push('login')
          },
          error() {
            console.log('error ' + this.context);
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "~vue-snotify/styles/material";

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue